export const domstolno = 'domstolno';
export const tilsynsutvalget = 'tilsynsutvalget';
